import type { Dict } from '@avtoklyuch/shared';
import { OVERRIDES } from './brand';
import { dict, type DictKey } from './dict';

/**
 * Словарь экземпляра: общие строки плюс то, что перекрыл профиль бренда.
 *
 * Все, кому нужны тексты — и разметка, и заголовки страниц — берут их отсюда,
 * а не из dict напрямую. Иначе <title> и og:description уедут общими, а
 * страница вокруг них будет брендированной: расхождение видно только
 * поисковику и всплывает месяцами позже.
 *
 * Слияние поверхностное и однократное, при импорте модуля: значения —
 * готовые тройки переводов, собирать их по одному языку нечего.
 */
export const texts = { ...dict, ...OVERRIDES } satisfies Dict<DictKey>;

export type { DictKey };
